var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-m-app-header',[_c('h1',{staticClass:"unicorn-h1 text-white"},[_vm._v(_vm._s(_vm.$route.meta))])])}
var staticRenderFns = []

export { render, staticRenderFns }